import React, { useState, useEffect } from "react";
import ChatHistory from "../components/ChatHistory";
import { useProfileTheme } from "../components/ProfileThemeProvider";
import styles from "./Chat.module.css";

const API_URL =
    process.env["NODE_ENV"] === "production"
        ? "/api/chat/"
        : //"https://crystaldsouza.northeurope.cloudapp.azure.com/api/chat/";
          "http://localhost:3001/api/chat/";

const Chat = () => {
    const [message, setMessage] = useState("");
    const [chatHistory, setChatHistory] = useState([]);
    const { refreshTheme } = useProfileTheme();

    useEffect(() => {
        const loadChatHistory = async () => {
            const userId = localStorage.getItem("userId");
            if (userId) {
                try {
                    const response = await fetch(`${API_URL}${userId}`);
                    const data = await response.json();
                    setChatHistory(data.history || []);
                } catch (error) {
                    console.error("Failed to load chat history:", error);
                }
            }
        };

        loadChatHistory();
    }, []);

    const handleSendMessage = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        if (message.trim()) {
            setMessage("");
            const userId = localStorage.getItem("userId");
            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ userId, message }),
            });

            const data = await response.json();
            setChatHistory([
                ...chatHistory,
                { user: message, bot: data.response },
            ] as [never, never]);

            // Refresh the theme after receiving a response
            await refreshTheme();
        }
    };

    return (
        <div className={`${styles.chatContainer} main-container`}>
            <h1>Chat</h1>
            <div className={`${styles.messageArea} rounded-alpha`}>
                <ChatHistory messages={chatHistory} />
            </div>
            <form className={styles.inputForm} onSubmit={handleSendMessage}>
                <input
                    className={styles.messageInput}
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type your message..."
                />
                <button
                    className={styles.sendButton + " btn"}
                    type="submit"
                    disabled={!message.trim()}
                >
                    Send
                </button>
            </form>
        </div>
    );
};

export default Chat;
